import { HIDE_OVERLAYS, SHOW_OVERLAY, UPDATE_OVERLAY } from "./constants";

import produce from "immer";

// The initial state of this store.
const initialState = {
    current: null,
    data: null,
    wrapper: null,
};

export default produce((state, action) => {
    switch (action.type) {
        case SHOW_OVERLAY:
            state.current = action.current;
            state.data = action.data;
            state.wrapper = action.wrapper;
            break;
        case HIDE_OVERLAYS:
            const hidingState = Object.assign({}, initialState);
            if (action.data) {
                hidingState.data = action.data;
            }

            return hidingState;
        case UPDATE_OVERLAY: {
            state.data = action.data;
            break;
        }
        default:
            break;
    }
}, initialState);
